<template>
    <div>
        <v-form>
          <v-layout>
                <v-flex xs3 v-if="available_namespaces && available_namespaces.length">
                <v-select v-model="local_namespace" :items="available_namespaces" label="Namespace"/>
                </v-flex>
                <v-flex>
                <v-text-field placeholder="Community Name" v-model="local_name"
                              @keypress.native.enter="confirm">
                </v-text-field>
                </v-flex>
            </v-layout>
            <v-card-text v-if="isNameInvalid" class="error-message">
                <span class="err-icon">
                </span>Name can only contain alphanumeric characters and whitespaces. No special characters allowed.
            </v-card-text>
            <v-card-text v-if="isNameAlreadyTaken" class="error-message">
                The name is already taken! Please use a different one.
            </v-card-text>
        </v-form>
        <v-card-actions class="btn-container">
            <v-btn class="custom-btn" color="secondary"
                    @click="confirm" :disabled="!isFormValid"
                    >Confirm
            </v-btn>
        </v-card-actions>
    </div>
</template>

<script>
    import CommunityService from "../../services/community.service"
    import _ from "lodash";

    export default {
        name: "CommunityName",
        props: ["namespace", "name", "available_namespaces", "check_name_availibility"],
        data: () => ({
            CommunityService,
            local_name: '',
            local_namespace: '',
            isNameAlreadyTaken: false,
            isNameInvalid: false,
            isFormValid: false,
            //availableWriteNamespaces: [],
            //namespace: "",
        }),
        computed: {
        },
        methods: {
            validateForm: _.throttle(function () {
                this.isNameAlreadyTaken = false;
                this.isNameInvalid = false;

                if ( this.local_name == "" ) {
                  this.isNameInvalid = true;
                  this.isFormValid = false;
                }

                let name_check_status = this.CommunityService.checkCommunityName(this.local_name);
                if ( name_check_status != this.CommunityService.STATUS_OK) {
                  this.isNameInvalid = true;
                  this.isFormValid = false;
                }
                else {
                  if (!this.check_name_availibility) {
                        this.isFormValid = true;
                  }
                  else {
                    let ns = this.local_namespace;
                    this.CommunityService.checkCommunityNameAvailibility(ns, this.local_name).then(status => {
                      if (status != this.CommunityService.STATUS_OK) {
                          this.isNameAlreadyTaken = true;
                          this.isFormValid = false;
                      } else {
                        this.isFormValid = true;
                      }
                    });
                  }
                }
              }, 200),
            confirm () {
                if (!this.isFormInvalid) {
                    this.$emit("confirm", {namespace: this.local_namespace, name: this.local_name});
                }
            },
        },
        mounted () {
            this.local_name = this.name || "";
            this.local_namespace = this.namespace || "";
            this.CommunityService = new CommunityService();
        },
        watch: {
            local_name (val, oldVal) {
                if (oldVal != val) {
                  this.validateForm();
                }
            },
            namespace (val, oldVal) {
                if (val && oldVal != val) {
                  this.local_namespace = val;
                }
            },
            name (val, oldVal) {
                if (val && oldVal != val) {
                  this.local_name = val;
                }
            },
        }
    }
</script>

<style scoped>

</style>
